import { render, staticRenderFns } from "./WiseView.vue?vue&type=template&id=0e16d6d0&scoped=true&"
import script from "./WiseView.vue?vue&type=script&lang=js&"
export * from "./WiseView.vue?vue&type=script&lang=js&"
import style0 from "./WiseView.vue?vue&type=style&index=0&id=0e16d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16d6d0",
  null
  
)

export default component.exports